import { useEffect, useState } from 'react';

/**
 * Trailing-edge debounce for a fast-changing value (spec 0008 round 2).
 * Feed the RAW value to the input and the debounced one to Apollo query
 * variables, so typing fires one network request per pause instead of one
 * per keystroke (same 300ms cadence as the command palette's search).
 */
export const useDebouncedValue = <T>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);
  return debounced;
};
